import type { HeaderFooterTheme } from './types';

/**
 * The background layer used for the footer, so it contrasts with the page theme.
 */
export function getInverseBackground(theme: HeaderFooterTheme) {
  return theme === 'white' ? 'grey' : 'white';
}
